module.exports = __webpack_public_path__ + "img/drawer-tanker.2e7660f4.svg";